import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c78ecb72"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c78ecb72&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c78ecb72')) {
      api.createRecord('c78ecb72', component.options)
    } else {
      api.reload('c78ecb72', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c78ecb72", function () {
      api.rerender('c78ecb72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Boys/MyLevel/index.vue"
export default component.exports